/*
 * @Date: 2022-04-15 13:52:16
 * @LastEditTime: 2022-07-04 10:46:05
 * @Description: file content
 * @FilePath: \traffic\src\routes\preview-page.js
 */
import React from "react";
import asyncComp from "core/lib/async-comp";
import styled from "styled-components";
import { Switch, Route } from "react-router-dom";
import { getParameterByName } from "@/utils/utils";

const FilePreview = asyncComp(() =>import("../pages/file-preview/file-preview").then()); // 文件预览
const AppletShare = asyncComp(() =>import("../pages/applet-share/index").then()); // 小程序跳转
const ErrorPreview = asyncComp(() =>import("../pages/error-page/error-page").then()) // 文件预览错误页

const Page = styled.div`
  width: 100%;
  height: 100%;
  background: #ecf0f4;
  display: flex;
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
`;

// 预览文件
const PreviewPage = () => {
  const err_code = getParameterByName('err_code')
  //目前暂不知道是否有其他页面使用err_code,暂时在文件预览路由处理
  const RealFilePreview = err_code ? ErrorPreview : FilePreview
  return (
    <Page>
      <Content>
        <Switch>
          <Route path={`/file-preview`} component={RealFilePreview} />
          <Route path={`/applet-share`} component={AppletShare} />
        </Switch>
      </Content>
    </Page>
  );
};

export default PreviewPage;
